import { SvgProps } from "@website/types";

const CopyIcon: React.FC<SvgProps> = ({
  width = 21,
  height = 22,
  fill = "black",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 22"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2H18C18.8284 2 19.5 2.67157 19.5 3.5V12.5C19.5 13.3284 18.8284 14 18 14H15V9.5C15 7.84315 13.6569 6.5 12 6.5H7.5V3.5C7.5 2.67157 8.17157 2 9 2ZM6 6.5V3.5C6 1.84315 7.34315 0.5 9 0.5H18C19.6569 0.5 21 1.84315 21 3.5V12.5C21 14.1569 19.6569 15.5 18 15.5H15V18.5C15 20.1569 13.6569 21.5 12 21.5H3C1.34315 21.5 0 20.1569 0 18.5V9.5C0 7.84315 1.34315 6.5 3 6.5H6ZM13.5 15.5V18.5C13.5 19.3284 12.8284 20 12 20H3C2.17157 20 1.5 19.3284 1.5 18.5V9.5C1.5 8.67157 2.17157 8 3 8H6V12.5C6 14.1569 7.34315 15.5 9 15.5H13.5ZM13.5 14H9C8.17157 14 7.5 13.3284 7.5 12.5V8H12C12.8284 8 13.5 8.67157 13.5 9.5V14Z"
        fill={fill}
      />
    </svg>
  );
};

export default CopyIcon;
